import messages from './messages';

const linkedSalesOrderWouldBeLost = 'IsOnlyLinkForSalesOrder';
const fulfillmentPlanWouldBeLost = 'HasNoOtherLinkedSalesOrders';
const hasLinkedInventoryItems = 'HasLinkedInventoryItems';
const invalidOrderGridStatus = 'InvalidOrderGridStatus';
export const unknownError = 'Unknown';

export const errorMessageFromCodeMap = {
  [linkedSalesOrderWouldBeLost]: messages.loneLinkedFulfillmentPlan,
  [fulfillmentPlanWouldBeLost]: messages.loneLinkedSalesOrder,
  [hasLinkedInventoryItems]: messages.hasLinkedInventory,
  [invalidOrderGridStatus]: messages.statusPreventsUnlinking,
  [unknownError]: messages.unknownUnlinkingError,
};
